export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9083.c6e46080.jpg";